import React from 'react';
import {
  FormattedMessage,
} from 'react-intl';
import moment from 'moment';

const EMPTY_VALIDATION_STATE_FOR_FIELD = undefined;

export const validateDateRange = (values) => {
  const errorArray = [];

  if (values) {
    values.forEach(({ startDate, dueDate }) => {
      const errors = {};

      if (startDate && dueDate && !moment.utc(dueDate).isAfter(moment.utc(startDate))) {
        errors.dueDate = <FormattedMessage id="ui-task-list.validation.dueDateAfterStartDate" />;
      }

      errorArray.push(errors);
    });
  }

  return errorArray;
};

export const validateRequiredField = value => (value ? undefined : <FormattedMessage id="ui-task-list.validation.required" />);

export const validateUniqueField = (values, selector) => (currentValue) => {
  let countOfUsingCurrentValue = 0;

  if (currentValue) {
    countOfUsingCurrentValue = values.filter(
      (rowValue) => rowValue[selector] === currentValue
    ).length;
  }

  return countOfUsingCurrentValue > 1
    ? <FormattedMessage id="ui-task-list.validation.unique" />
    : undefined;
};

export const validateFieldLength = (value, maxLength) => {
  if (value) {
    const str = value.toString();
    const errorMsg = (
      <FormattedMessage
        id="ui-task-list.validation.maxLength"
        values={{ maxLength }}
      />
    );

    return str.length <= maxLength ? EMPTY_VALIDATION_STATE_FOR_FIELD : errorMsg;
  }

  return EMPTY_VALIDATION_STATE_FOR_FIELD;
};

export const validateUrl = (value) => {
  const rules = new RegExp('^$|([Hh][Tt][Tt][Pp]|[Ff][Tt][Pp])([Ss])?://.+$');

  return rules.test(value)
    ? EMPTY_VALIDATION_STATE_FOR_FIELD
    : <FormattedMessage id="ui-task-list.validation.url" />;
};

export const composeValidators = (...validators) => values => {
  return validators.reduce((error, validator) => error || validator(values), EMPTY_VALIDATION_STATE_FOR_FIELD);
};
